import useBooleanConfig from './useBooleanConfig';

export default function useStreetEasyLeadManagementEnabled(): boolean {
  return useBooleanConfig('enableStreetEasyLeadManagement', false);
}
